import { call, put } from 'redux-saga/effects'

import { COMPANY_STATUS_TRANSITION_TYPE } from '../../../constants/enums/company.enum.constant'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { requestFailure, updateCompanyStatusSucceed } from '../actions'

export function* updateCompanyStatusSaga(
  companyApi: {
    updateCompanyStatus: (...args: any[]) => any
  },
  {
    payload: { companyId, action }
  }: {
    payload: {
      companyId: string
      action: keyof typeof COMPANY_STATUS_TRANSITION_TYPE
    }
  }
) {
  try {
    const { data } = yield call(
      companyApi.updateCompanyStatus,
      companyId,
      action
    )
    yield put(updateCompanyStatusSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
